import { render, staticRenderFns } from "./CompraDatos.vue?vue&type=template&id=0b6fc80f&"
import script from "./CompraDatos.vue?vue&type=script&lang=js&"
export * from "./CompraDatos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports